import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pwd",
  "use": "icon-pwd-usage",
  "viewBox": "0 0 300 300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 300 300\" overflow=\"visible\" id=\"icon-pwd\">\r\n<g>\r\n\t<path d=\"M254.17,295.83H45.83c-11.51,0-20.83-8.71-20.83-19.45V130.55c0-10.73,9.33-19.44,20.83-19.44h208.33\r\n\t\tc11.51,0,20.83,8.71,20.83,19.44v145.83C275,287.13,265.67,295.83,254.17,295.83L254.17,295.83z M150,159.72\r\n\t\tc-17.26,0-31.25,13.05-31.25,29.17c0,10.76,6.33,20.07,15.63,25.12v27.75c0,8.38,7,15.19,15.63,15.19\r\n\t\tc8.62,0,15.63-6.81,15.63-15.19v-27.75c9.3-5.05,15.62-14.35,15.62-25.12C181.25,172.78,167.26,159.73,150,159.72L150,159.72\r\n\t\tL150,159.72z M150,33.33c-34.52,0-62.5,26.11-62.5,58.33H56.25c0-48.32,41.97-87.5,93.75-87.5c51.78,0,93.75,39.17,93.75,87.5\r\n\t\tH212.5C212.5,59.44,184.52,33.33,150,33.33L150,33.33z M150,33.33\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/pwd.svg
// module id = lQU/
// module chunks = 34